export interface IProductCostings {
  id: number;
  guid?: string;
  createdDate?: Date;
  modifiedDate?: Date;
  version?: number;
  productId: number;
  vatRateId: number;
  cost?: number;
}

export interface IProductCostingsCreate {
  productId: number;
  vatRateId: number;
  cost?: number;
}

export interface IProductCostingsUpdate {
  id: number;
  productId?: number;
  vatRateId?: number;
  cost?: number;
}
